module.exports = __webpack_public_path__ + "img/gamesdk13.a8754c2.png";